import Api from './api.js';
import axios from 'axios';

export class AskQuoteApi extends Api {
    constructor(options = {}) {
        super(options);

        this.emailApiPath = 'email';
    }

    async sendMessage(options) {
        return await this.axiosInstance.request({
            method: 'post',
            url: this.emailApiPath,
            data: {
                subject: 'Solmar Limpezas - Pedido de Contacto',
                html:  this.buildMessage(options),
                to: 'geral@solmarlimpezas.com'
            }
        });
    }

    buildMessage({name, contact, message}){
        const header = 'Recebeu uma nova mensagem de pedido de contacto através do site solmarlimpezas.com';
        return `${header} <br/>Nome:${name} <br/>Contacto:${contact} <br/>Mensagem:${message}`;
    }
}
